<div class="glo-control w-full flex text-center relative">
    <!-- Left Icon -->
    @if(showIcon && icon) {
        <span class="absolute inset-y-0 left-4 flex items-center z-10">
            <img [src]="assetUrl + 'icons/' + icon + '.svg'" class="h-5 w-5" />
        </span>
    }

    <!-- Input -->
    @if(!type || type === types.text) {
        <input
          type="text"
          [placeholder]="placeholder"
          [value]="value"
          (input)="onInput($event)"
          class="w-full pl-[46px]"
          [ngClass]="classes" />

        @if(rightIcon) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4">
                <img [src]="assetUrl + 'icons/'+ rightIcon +'.svg'" alt="help icon" class="w-4 h-4" />
            </span>
        }
    }

    @if(type === types.calendar) {
        <input
          type="date"
          [placeholder]="placeholder"
          [value]="value"
          (input)="onInput($event)"
          class="w-full pl-[46px]"
          [ngClass]="classes || ''" />
    }

   <ng-container *ngIf="type === types.select">
    <ng-select
        [items]="options"
        [(ngModel)]="value"
        (ngModelChange)="onNgModelChange($event)"
        class="custom-ng-select"
        [placeholder]="placeholder"
        [bindLabel]="showKey"
        [bindValue]="valueKey"
        [searchable]="true"
        [clearable]="false"
        [disabled]="isDisabled">
        <!-- optional custom label template -->
    </ng-select>
    </ng-container>




</div>
